import React from "react";

interface JudiMarkProps {
  className?: string;
}

/**
 * The JuDI logo symbol: a bookmark ribbon folded into a check. The short
 * arm is the ribbon's front and the long arm its folded-over back.
 *
 * The brand pairs are fixed: #b8872e / #9a6f1e on light, #e8cb8a / #d4ae62
 * on dark (see docs/brand/ribbon-check). The accent tokens hit the light pair
 * exactly, but in dark mode `primary` / `primary-dark` resolve to #d4ae62 /
 * #b8872e — one step too dark — so the dark variants move each face one token
 * lighter to match the favicon, the splash screens and the iPhone app.
 *
 * Decorative — the name "JuDI" (visible or screen-reader-only) or the
 * surrounding label always carries the text.
 */
const JudiMark: React.FC<JudiMarkProps> = ({ className = "w-7 h-7" }) => (
  <svg
    viewBox="0 0 214.49 200"
    className={`flex-shrink-0 ${className}`}
    aria-hidden="true"
    focusable="false"
  >
    <path
      className="fill-warm-blue-dark dark:fill-warm-blue"
      d="M72.14 136.74L79.46 196.29A9.01 9.01 0 0 0 85.46 192.9L211.26 31.88A2.25 2.25 0 0 0 209.26 28.25L183.55 30.74L179.75 5.19A2.25 2.25 0 0 0 175.74 4.14Z"
    />
    <path
      className="fill-warm-blue dark:fill-warm-blue-light"
      d="M4.26 140.9A5.41 5.41 0 0 1 3.33 133.3L24.42 106.31A5.41 5.41 0 0 1 32.01 105.38L72.14 136.74L79.46 196.29A9.01 9.01 0 0 1 72.81 194.45Z"
    />
  </svg>
);

export default JudiMark;
